
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { requiredBoolean } from './required-boolean.validator';

export function getCreateTeamDtoFormGroup() {
return new FormGroup({
    name: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(45)]),
    shortname: new FormControl<string | undefined>('', [Validators.maxLength(20)]),
    roletypeName: new FormControl<string | undefined>(undefined, [Validators.maxLength(100)]),
    active: new FormControl<boolean | undefined>(true, [requiredBoolean()]),
    montageplanType: new FormControl<string | undefined>(undefined),
    businessdivisionId: new FormControl<number | undefined>(undefined),
})
;
}
      